export const fields = {
  number: require("./number.js").default,
  vector3: require("./vector3.js").default,
  image: require("./image.js").default
}
